<script>
  import Button from "@components/Button.svelte"

  export let collection
  export let account

  const showLogo = account.image.exists && ["both", "logo"].includes(account.theme.branding)
</script>

<div class="[ flex flex-col md:flex-row md:justify-center md:items-center ]">
  <div>
    <div class="[ flex ]">
      {#if showLogo}
        <div class="[ flex items-center min-w-[3.5rem] shrink-0 relative mr-4 ]">
          <div class="[ aspect-square ]">
            <img
              src={account.image.url}
              height="70"
              width="70"
              loading="lazy"
              alt="{account.name} Logo"
              class="[ rounded ]"
            />
          </div>
        </div>
      {/if}
      <div>
        <h1 class="[ font-heading text-lg font-semibold md:text-xl ]">
          {collection.name}
        </h1>
        <p class="[ mt-1 text-sm tracking-wide ]">
          {account.name}
        </p>
      </div>
    </div>
  </div>
  <Button
    type="primary"
    size="small"
    href={collection.url}
    external
    class="
      [ font-bold tracking-tight ]
      [ mt-4 md:mt-0 w-full md:w-auto ]
      [ md:ml-auto ]
    "
  >
    View Collection
  </Button>
</div>
